Core.FormsRouter = Core.SubRouter.extend({

    routes: {
        '': 'forms',
        'new': 'newForm',
        ':id': 'viewForm',
        ':id/edit': 'editForm'
    },

    forms: function () {
        debug.log('Forms');
        var param = Core.param();
        var view = new FormDetailsView({
            sharedView: typeof Core.param().shared != 'undefined',
            customerView: typeof Core.param().customer != 'undefined' && isNaN(parseInt(Core.param().customer))
        });
        if (Core.param().returnTo) view.saveAction = Core.param().returnTo;
        var hash = Core.param().hash
        if (hash) {
            this.navigate(hash, { trigger: true, replace: true});
        } else {
            console.error('Uhhh... WHERE TO?'); // Copypaste from formdetails.xhtml
        }
        app.setMainView(view, 'directory');
    },

    newForm: function () {
        debug.log('new form');
        var view = new FormDetailsView({
            sharedView: typeof Core.param().shared != 'undefined',
            customerView: typeof Core.param().customer != 'undefined' && isNaN(parseInt(Core.param().customer))
        });
        if (Core.param().returnTo) view.saveAction = Core.param().returnTo;
        view.editing = true;
        view.setModel(new CustomForm({ template: Core.param().template != undefined }));
        if (!view.model.get('template') && Core.param().usetemplate) {
            view.useTemplate(Core.param().usetemplate, Core.param().job);
        }
        if (Core.param().job) {
            view.model.set({jobId: parseInt(Core.param().job)});
        }
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    },

    viewForm: function (id) {
        debug.log('view form:', id);
        var view = new FormDetailsView({
            sharedView: typeof Core.param().shared != 'undefined',
            customerView: typeof Core.param().customer != 'undefined' && isNaN(parseInt(Core.param().customer))
        });
        if (Core.param().returnTo) view.saveAction = Core.param().returnTo;
        view.editing = false;
        if (!view.model || view.model.id != id)
            view.setModel(new CustomForm({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    },

    editForm: function (id) {
        debug.log('edit form:', id);
        var view = new FormDetailsView({
            sharedView: typeof Core.param().shared != 'undefined',
            customerView: typeof Core.param().customer != 'undefined' && isNaN(parseInt(Core.param().customer))
        });
        if (Core.param().returnTo) view.saveAction = Core.param().returnTo;
        view.editing = true;
        if (!view.model || view.model.id != id)
            view.setModel(new CustomForm({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'jobs');
    }
})
